<template>
  <div class="button-group-wrapper">
    <b-row >
      <b-col sm="6" lg="4">
        <div class="button-box shadow">
          <modal />
        </div>
      </b-col>
      <last-updated-draft />
      <info-tour />
    </b-row>
  </div>
</template>

<script>
  import Modal from '@/components/overview/Modal.vue'
  import LastUpdatedDraft from '@/components/overview/LastUpdatedDraft.vue'
  import InfoTour from '@/components/overview/InfoTour.vue'

  export default {
    methods: {
      startIntroAgain () {
        this.$store.dispatch('intro/ACTIVATE_INTRO_SET_FALSE').then(res => {
          const { errors } = res
          if (errors) {
            console.error(errors)
          }
          this.$router.push({
            name: 'uebersicht'
          }).catch((e) => {})
        }).catch(err => {
          console.error(err)
        })
      }
    },
    components: {
      Modal,
      LastUpdatedDraft,
      InfoTour
    }
  }
</script>

<style lang="scss" scoped>
  .button-group-wrapper{
    margin-bottom: 1rem;

    .button-box{
      background: $white;
      position: relative;
      height: 100%;
      padding-bottom: 2rem;

      .button-box-body{
        padding: 1rem .5rem;

        small{
          display: block;
        }
        p{
          margin-bottom: 0;
        }
      }

      .icon-lg{
        display: flex;
        width: 80px;
        height: 80px;
        background: $magenta;
        line-height: 1;
        align-items: center;
        justify-content: center;
        color: $white;
        text-decoration: none;
        margin: 0 auto;
        font-size: $font-size-sm * 3;

        span{
          color: $white;
        }
      }

      .button-legend{
        background: $black-80;
        color: $white;
        text-align: center;
        padding: .5rem .75rem;
        font-size: $font-size-lg;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
      }

      .icon-circle{
        font-size: 1.75rem;
      }
    }
  }
</style>
